<!-- 审核账户信息 -->
<script setup>
import { ref, onMounted, watch, onUnmounted, nextTick } from 'vue';
// import companyImg from "@/assets/images/account/company.png"
import i18n from "@/i18n"
import { getBusinessInfoDetail, database_template_name_v3, getFileUrl, user_review_v3, permission_tree_v3, set_permission_user_v3, get_permission_user_v3, company_type_list } from "@/service/index"
import { useRoute, useRouter } from 'vue-router';
import PreviewImg from "@/components/common/PreviewImg";
import { showMessage } from "@/utils/hooks/message"
import countryListData from '@/utils/country.js';
import { getLangValue, getLangValueByKey, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
const currendData = ref({})
const route = useRoute()
const router = useRouter()
const showBarIndex = ref(0)
const reviewComments = ref("") // 审核意见
const companyAddressList = ref([])
const contact_address = ref([])
const showPreviewImg = ref(false) //资质
const showPreviewImg1 = ref(false) // logo
const srcList = ref([])
const srcList1 = ref([])
const treeRef = ref(null)
const currentStatus = ref(2) // 默认待审核-提交完善资料
const tabList = [
    {
        id: 0,
        name: getLangValue('business-user', "functionalpermissions"),
        icon: 'ri-group-fill'
    }
]
const permission_tree = ref([])
const companyTypeList = ref([])
const current_tab = ref(0)
const main_business_areas_list = ref([])
const showloading = ref(false) // 是否显示加载中
const PageHeaderT = getLangValue('business-user', "title")
const PageHeaderItems = [
    {
        text: getLangValue('business-user', "title"),
        active: false,
        href: `/business_information_management?search_type=${route.query.search_type || 0}`,
    },
    {
        text: getLangValue('business-user', "subtitle1"),
        active: true,
    },
]
const reject = async () => {
    /**驳回 */
    showloading.value = true
    try {
        if (!reviewComments.value) {
            showMessage('danger', getLangValue('business-user', "please_input_reject_reason"))
            showloading.value = false
            return false
        }
        let params = {
            passed: 0,
            description: reviewComments.value
        }
        const resp = await user_review_v3(route.query.id, params)
        showloading.value = false
        if (resp.code == 0) {
            showMessage('success', getLangValue('business-user', "rejectedsuccessfully"))
            router.push({ path: '/business_information_management', query: { search_type: route.query.search_type || 0 } })
        } else {
            showMessage('danger', resp.message)
        }
    } catch (e) {
        console.log(e);
        showloading.value = false
    }

}

const next = async () => {
    /**下一步 */
    if (showBarIndex.value <= 1) {
        showBarIndex.value++
    }
    // 如果是3不 复现权限
    // && currentStatus.value == 3
    if (showBarIndex.value == 2) {
        //查询权限tree
        await get_permission_tree_v3();
        // 查询用户权限
        let params = {
            user_id: route.query.id,
        }
        const resp = await get_permission_user_v3(params)
        if (resp.code == 0) {
            treeRef.value.setCheckedKeys(resp.payload)
        } else {
            showMessage('danger', resp.message)
        }
    }
    nextTick(() => {
        nextProgress()
    })

}

const getImage = async () => {
    // 获取图片
    let arr = currendData.value.company_logo ? [...currendData.value.company_qualification, ...[currendData.value.company_logo]] : [...currendData.value.company_qualification]
    let imgIdStr = arr.join(',')
    // console.log(imgIdStr);
    if (imgIdStr)
        getFileUrl({ attachments: imgIdStr }).then(resp => {
            if (resp) {
                //设置图片1
                let arr_qualification_documents = resp.payload.filter(item => currendData.value.company_qualification.includes(item.id))
                srcList.value = arr_qualification_documents
                // formData.value.qualification_documents = arr_qualification_documents
                if (currendData.value.company_logo) {
                    //设置图片2
                    let arr_logo = resp.payload.filter(item => currendData.value.company_logo.includes(item.id))
                    srcList1.value = arr_logo
                    // formData.value.logo = arr_logo
                }


            }
        })
}
const getDetailByid = async () => {
    let xx = true
    if (xx) {
        const resp = await getBusinessInfoDetail(route.query.id);
        if (resp.code == 0) {
            currentStatus.value = resp.payload.status
            if (resp.payload.status == 3) {
                // 待审核-更新资料
                currendData.value = resp.payload.wait_review_info
            } else {
                // 待审核-提交完善资料
                currendData.value = resp.payload
            }
            getImage()
            // let imgIdStr = currendData.value.company_qualification.join(',')
            // if (imgIdStr)
            //     getFileUrl({ attachments: imgIdStr }).then(resp => {
            //         if (resp) {
            //             srcList.value = resp.payload
            //         }
            //     })
            // let imgIdStr1 = currendData.value.company_logo
            // if (imgIdStr1)
            //     getFileUrl({ attachments: imgIdStr1 }).then(resp => {
            //         if (resp) {
            //             srcList1.value = resp.payload
            //             // formData.value.logo = resp.payload
            //         }
            //     })
        } else {
            showMessage('danger', resp.message)
        }
    } else {
        currendData.value = {
            "company_name": "金科组数",
            "company_type": "生产商",
            "contact_first_name": "feng",
            "contact_last_name": "tao",
            "contact_email": "11107949255@qq.com",
            "landline_number": "2659866",
            "mobile_phone_number": "15108343658",
            "certification_company": true,
            "business_scope": "668e23af5c727ced7814c51c",
            "place_of_incorporation": "dwq ",
            "certificate_number": "dwq131",
            "company_qualification": [
                "66988197b9fc9a463208f059",
                "6699cb1c571be011cb92bbb0"
            ],
            "logo": [
                "6699cb1c571be011cb92bbb0"
            ],
            "Enterprise_registered_country": "阿富汗",
            "phoneCountry": "阿富汗",
            "phone_numberCountry": "安哥拉",
            "company_address": [
                {
                    "name": "AF",
                    "country": "阿富汗",
                    "province": "11",
                    "city": "11",
                    "address1": "1",
                    "address2": "",
                    "address3": "",
                    "postcode": "1"
                },
                {
                    "name": "AF",
                    "country": "阿富汗",
                    "province": "1",
                    "city": "11",
                    "address1": "1",
                    "address2": "",
                    "address3": "",
                    "postcode": "1"
                }
            ]
        }
    }

}
const handlerToggleTab = (i) => {
    current_tab.value = i
}
const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    } else if (fileType == 'dwg' || fileType == 'dwt' || fileType == 'dxf' || fileType == 'dwf') {
        return 'cad'
    }
    return 'file'
}
const viewFile = (type = 0) => {
    /**展示附件信息 */
    // activeImageSrc.value = 'http://localhost:8080/static/img/company.29dfa381.png';
    // if (activeImageSrc.value == "") {
    //     return;
    // }
    // console.log(type);
    if (type == 0) {
        if (srcList.value.length == 0) {
            showMessage('danger', getLangValue('base.no_pictures'))
            return
        }
        // 需要判断是图片还是附件
        const type = setType(srcList.value[0].name)
        if (type == 'image') {
            showPreviewImg.value = true;
        } else {
            window.open(srcList.value[0].url, '_blank')
        }
    } else {
        if (srcList1.value.length == 0) {
            showMessage('danger', getLangValue('base.no_pictures'))
            return
        }
        showPreviewImg1.value = true;
    }

}

const getTree = (arr) => {
    let arr1 = arr.map(item => {
        let m = {
            id: item.slug,
            label: item.name,
            children: [],
        }
        if (item.permissions && item.permissions.length) {
            m.children = getTree(item.permissions)
        }
        return m
    })
    return arr1
}

const confirm = async () => {
    // 确认提交用户的权限以及修改用户状态
    // 判断是否勾选权限
    showloading.value = true
    try {

        let arr = treeRef.value.getCheckedKeys()
        // console.log(arr);
        if (arr.length == 0) {
            showMessage('danger', getLangValue('business-user', "noUserPermissions"))
            return false
        }
        let params = {
            user_id: route.query.id,
            permissions: arr
        }
        const resp = await set_permission_user_v3(params)
        showloading.value = false
        if (resp.code == 0) {
            // 修改用户状态
            const resp1 = await user_review_v3(route.query.id, { passed: 1 })
            if (resp1.code == 0) {
                showMessage('success', getLangValue('business-user', "examineSuccess"))
                router.push({ path: '/business_information_management', query: { search_type: route.query.search_type || 0 } })
            } else {
                showMessage('danger', resp1.message)
            }
        } else {
            showMessage('danger', resp.message)
        }
    } catch (e) {
        console.log(e);
        showloading.value = false
    }
}

const get_permission_tree_v3 = async () => {
    /**获取权限tree */
    const resp = await permission_tree_v3()
    if (resp.code == 0) {
        // console.log(resp.payload)
        permission_tree.value = getTree(resp.payload)
    } else {
        showMessage('danger', resp.message)
    }
}
const handleResize = () => {
    let dom = document.getElementById('logo_examine')
    if (dom)
        dom.style.height = dom.clientWidth + 'px'
}

const getCountryNameByKey = (countryKey) => {
    if (countryKey) {
        return i18n.global.locale == 'en' ? countryListData.filter(item => item.key === countryKey)[0].en : countryListData.filter(item => item.key === countryKey)[0].zh;
    } else {
        return ''
    }
}
const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
    }
}

const getCompanyTypeName = (str) => {
    // 根据企业类型id获取名字
    let arr = str ? str.split(',') : []
    let name = []
    for (const item in arr) {
        let arr1 = companyTypeList.value.filter(item1 => item1.id == arr[item])
        if (arr1.length) {
            name.push(arr1[0].name)
        }
    }
    return name.join(',')
}

const normalizeUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
        return 'https://' + url;
    }
    return url;
}

const openWeb = (url) => {
    if (!url) return
    const safeUrl = normalizeUrl(url);
    window.open(safeUrl, '_blank')
}

const nextProgress = () => {
    let progressBar = document.querySelector(`.activeProgress${showBarIndex.value}`);
    let progress = 0;
    let timer;
    function updateBackground() {
        if (progress <= 100) {
            // Update the background with the new progress percentage
            progressBar.style.backgroundImage = `linear-gradient(to right, #9599AD ${progress}%, black ${100 - progress}%)`;
            progress++; // Increase the progress by 1% each time
        } else {
            clearInterval(timer)
        }
    }

    // Update the background every 100ms to simulate gradual transition
    timer = setInterval(updateBackground, 10);
}

const back = () => {
    showBarIndex.value--;
    nextTick(() => {
        backProgress()
    })
}
const backProgress = () => {
    let progressBar = document.querySelector(`.backProgress${showBarIndex.value}`);
    let progress = 0;
    let timer;
    function updateBackground() {
        if (progress <= 100) {
            progress++; // Increase the progress by 1% each time
            progressBar.style.backgroundImage = `linear-gradient(to left, black ${progress}%, #9599AD ${100 - progress}%)`;
            progress++; // Increase the progress by 1% each time

        } else {
            clearInterval(timer)
        }
    }

    // Update the background every 100ms to simulate gradual transition
    timer = setInterval(updateBackground, 10);
}

const getTemplateList = async () => {
    // let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    // if (data.length > 0) {
    //     main_business_areas_list.value = data;
    // } else {
    let params = {
        status: 1,
    }
    const reps = await database_template_name_v3(params)
    if (reps) {
        if (reps.payload.length == 0) {
            main_business_areas_list.value = [{ name: getLangValueByKey('base.none'), name_en: getLangValueByKey('base.none', 'en'), role_key: '无', }]
        } else {
            main_business_areas_list.value = reps.payload;
        }
    }
    // }
}

const get_business_scope = (business_scope_list) => {
    // 获取信息
    let str = [];
    for (const item in business_scope_list) {
        const role_key = business_scope_list[item]
        let obj = main_business_areas_list.value.find(item => item.role_key === role_key)
        if (obj) {
            str.push(i18n.global.locale == 'en' ? obj.name_en : obj.name);
        }
    }
    return str.join('/');
}

onMounted(() => {
    getTemplateList();
    getDetailByid()
    // get_permission_tree_v3();
    // 窗口宽度监听
    window.addEventListener('resize', handleResize);
    getCompany_type_list();
})
onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
})

// defineExpose({
//     currendData
// })
watch(currendData, (val) => {
    companyAddressList.value = val.company_address.map(item => {
        return {
            country: item.name,
            countryKey: item.country,
            province: item.province,
            province_code: item.province_code,
            city: item.city,
            address: item.address1,
            postcode: item.postcode,
        }
    })
    contact_address.value = val.contact_address.map(item => {
        return {
            country: item.name,
            countryKey: item.country,
            province: item.province,
            city: item.city,
            address: item.address1,
            postcode: item.postcode,
        }
    })

})
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);" v-loading="showloading">
            <div class="w-100 h-100 bg-white card p-4 my-scroll-bar" style="overflow-y: auto;">
                <div class="d-flex justify-content-center">
                    <img id="logo_examine" v-if="srcList1.length" :src="srcList1.length ? srcList1[0].url : ''"
                        style="max-width: 250px; max-height: 250px; width: 20%; min-width: 100px;" />
                    <Empty v-else :content="getLangValue('base.no_pictures')"></Empty>
                </div>
                <!-- 进度条 -->
                <div style="width: 958px; height: 750px; margin: 0 auto;">
                    <div class="progressbar d-flex align-items-center mt-2 mb-4" style="height: 58px;">
                        <div class="flex-1 d-flex align-items-center">
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                <i style="font-size: 24px; color: white;" class=" ri-arrow-left-s-line"></i>
                            </div>
                            <hr style="width: calc(100% - 40px); background-color: #9599AD; opacity: 1; height: 4px" />
                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 0 ? 'active2111' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            1
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('business-user', 'examine') }}</div>
                                    </div>
                                    <hr :class="showBarIndex >= 1 ? 'activeProgress1' : 'backProgress0'"
                                        style="width: calc(100% - 40px); background-color: #212529; opacity: 1;  height: 4px" />
                                </div>
                            </div>

                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 1 ? 'active2111' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            2
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('business-user', 'examine1') }}</div>
                                    </div>
                                    <hr :class="showBarIndex >= 2 ? 'activeProgress2' : 'backProgress1'"
                                        style="width: calc(100% - 40px);  background-color: #212529;; opacity: 1;height: 4px" />
                                </div>
                            </div>
                        </div>
                        <div class="flex-1" style="position: relative;">
                            <div>
                                <div class="d-flex align-items-center" style="height: 40px;">
                                    <div class="d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px; ">
                                        <div :class="showBarIndex == 2 ? 'active2111' : ''"
                                            style="width: 22px; height: 22px; background-color: #9599AD; border-radius: 50%; text-align: center; color: white; margin: 0;">
                                            3
                                        </div>
                                        <div
                                            style="position: absolute; bottom: -12px; min-width: 300px; text-align: center;">
                                            {{ getLangValue('business-user', 'examine2') }}</div>
                                    </div>
                                    <hr
                                        style="width: calc(100% - 40px); background-color: #9599AD;; opacity: 1;height: 4px" />
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="d-flex align-items-center justify-content-center"
                                style="width: 40px; height: 40px; background-color: #9599AD; border-radius: 50%;">
                                <i style="font-size: 24px; color: white;" class=" ri-arrow-right-s-line"></i>
                            </div>
                        </div>
                    </div>
                    <!-- 详细信息 -1 -->
                    <div class="info-1" v-show="showBarIndex == 0">
                        <div class="d-flex  flex-column" style="width: 500px; margin:  0 auto;">
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;min-width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_companyName') }}</span>
                                    </div>
                                    <label class=" mx-3"
                                        style="flex: 1;text-align: left;word-wrap: break-word;word-break: normal; white-space: normal;">
                                        {{ currendData.company_name }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_Enterprisetype') }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;">
                                        {{ getCompanyTypeName(currendData.company_type) }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_contacts') }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;">
                                        {{ currendData.contact_first_name + currendData.contact_last_name }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_email') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.contact_email }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_phone') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.landline_number_area }}-
                                        {{ currendData.landline_number }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_phone_number') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.mobile_phone_number_area }}-
                                        {{ currendData.mobile_phone_number }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_main_business_areas') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.business_scope && currendData.business_scope.length ?
                                            get_business_scope(currendData.business_scope) : '' }}
                                    </label>
                                </div>
                            </div>
                            <!-- <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'from_is_check_company') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.testing_company ? '是' : '否' }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'from_is_certification_company') }}</span>
                                    </div>
                                    <label class=" mx-3">
                                        {{ currendData.certification_company ? '是' : '否' }}
                                    </label>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <!-- 详细信息 -2 -->
                    <div class="info-2" v-show="showBarIndex == 1">
                        <div class="d-flex  flex-column" style="width: 500px; margin:  0 auto;">
                            <div class=" col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;min-width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_Enterprise_registered_address')
                                            }}</span>
                                    </div>
                                    <label class="mx-3"
                                        style="flex: 1;text-align: left;word-wrap: break-word;word-break: normal; white-space: normal;">
                                        {{ currendData.place_of_incorporation }}
                                        ({{ getCountryNameByKey(currendData.place_of_incorporation) }})
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_Certificate_No') }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;">
                                        {{ currendData.certificate_number }}
                                    </label>
                                </div>
                            </div>
                            <!-- 检测机构才有的新增字段 -->
                            <div class="col-100 myC-3"
                                v-if="currendData.company_type && currendData.company_type.includes('7')">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_qualification_certification')
                                            }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;">
                                        {{ currendData.company_qualification_validity_period }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3"
                                v-if="currendData.company_type && currendData.company_type.includes('7')">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_qualification_certification1')
                                            }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;">
                                        {{ currendData.company_qualification_certification_body }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_company_link') }}</span>
                                    </div>
                                    <label class=" mx-3" style="flex: 1;text-align: left;word-break: break-all;">
                                        <a @click="openWeb(currendData.company_website)"
                                            style="text-decoration: underline !important;color: #6691E7;">{{
                                                currendData.company_website }}</a>
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'form_qualification_documents') }}</span>
                                    </div>
                                    <label class="mx-3 cursor-pointer" @click="viewFile(0)"><a
                                            style="color: #6691E7; text-decoration: underline !important;"> {{
                                                getLangValue('business-user', 'viewfile') }}</a>
                                    </label>
                                </div>
                            </div>
                            <div class="col-100 myC-3">
                                <div class="d-flex align-items-center justify-content-start">
                                    <div style="width: 120px;">
                                        <span>{{ getLangValue('my.account', 'logo') }}</span>
                                    </div>
                                    <label class="mx-3 cursor-pointer" @click="viewFile(1)"><a
                                            style="color: #6691E7; text-decoration: underline !important;"> {{
                                                getLangValue('business-user', 'viewfile') }}</a>
                                    </label>
                                </div>
                            </div>
                            <!-- 生产地址 -->
                            <div v-for="(item, key) in companyAddressList" :key="key">
                                <div class="d-flex align-items-center">
                                    <div style="min-width: 120px;color: #212529; font-weight: 600; ">
                                        {{ getLangValue('my.account', 'enterprise_production_address') }} {{ key + 1 }}
                                    </div>
                                    <!-- <i class="ri-delete-bin-fill cursor-pointer" style="color: red;" v-if="key > 0"
                            @click="removeProductAddress(key)"></i> -->
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_country') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.country }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_province') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.province }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_province_code') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.province_code }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_City') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.city }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_address') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.address }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_post') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.postcode }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- 企业通讯地址 -->
                            <div v-for="(item, key) in contact_address" :key="key">
                                <div class="d-flex align-items-center">
                                    <div style="min-width: 120px;color: #212529; font-weight: 600; ">
                                        {{ getLangValue('my.account', 'contact_address') }}
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_country') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.country }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_province') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.province }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_City') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.city }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_address') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.address }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-100 myC-3">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div style="width: 120px;">
                                            <span>{{ getLangValue('my.account', 'form_post') }}</span>
                                        </div>
                                        <label class=" mx-3">
                                            {{ item.postcode }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 权限信息 -->
                    <div class="info-3" v-show="showBarIndex == 2">
                        <div class="d-flex  flex-column" style="margin:  0 auto;">
                            <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center "
                                role="tablist" style="border-bottom: 1px dashed #E9EBEC; padding: 0;">
                                <li class="nav-item" v-for="(tab, i) in tabList" :key="i"
                                    style="min-width: 115px; text-align: center;">
                                    <a :class="[
                                        'nav-link',
                                        'All',
                                        'position-relative cursor',
                                        i == current_tab && 'active11 active',
                                    ]" @click="handlerToggleTab(i)"
                                        style="color: #0AB39C; font-weight: 600; font-size: 13px;">
                                        <i :class="tab.icon" class="mx-2"></i>{{ tab.name }}
                                    </a>

                                </li>
                            </ul>
                            <!-- 权限树 -->
                            <div class="my-2">
                                <el-tree ref="treeRef" style="max-width: 600px" :data="permission_tree" show-checkbox
                                    node-key="id" default-expand-all />
                            </div>
                        </div>
                    </div>
                    <!-- 按钮 -->
                    <div style="width: 500px; margin: 0px auto;" v-show="showBarIndex <= 1">
                        <div class="col-100 myC-3" v-permit="'business-user.review'">
                            <div class="" style="min-width: 120px;">
                                <span>{{ getLangValue('business-user', 'examine3') }}</span>
                            </div>
                            <textarea class="form-control" id="exampleFormControlTextarea5" rows="3"
                                v-model="reviewComments"></textarea>
                        </div>
                        <!-- 按钮 -->
                        <div class="d-flex align-items-center justify-content-center myC-3">
                            <b-button v-if="showBarIndex == 1" class="mx-2" variant="success" @click="back"
                                style="min-width: 104px;">
                                {{ getLangValue('my.account', 'btn_back') }}
                            </b-button>
                            <b-button v-permit="'business-user.review'" class="mx-2" variant="success" @click="reject"
                                style="min-width: 104px;">
                                {{ getLangValue('business-user', 'examine4') }}
                            </b-button>
                            <b-button class="mx-2" variant="success" @click="next" style="width: 104px;">
                                {{ getLangValue('login.next') }}
                            </b-button>
                        </div>
                    </div>
                    <div style="width: 500px; margin: 0px auto;" v-show="showBarIndex == 2">
                        <!-- 按钮 -->
                        <div class="d-flex align-items-center justify-content-center myC-3">
                            <b-button class="mx-2" variant="success" @click="back" style="min-width: 104px;">
                                {{ getLangValue('my.account', 'btn_back') }}
                            </b-button>
                            <b-button v-permit="'business-user.review'" class="mx-2" variant="success" @click="confirm"
                                style="width: 104px;">
                                {{ getLangValue('base.confirm') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :srcList="srcList" v-if="showPreviewImg"></PreviewImg>
        <PreviewImg v-model:showPreviewImg="showPreviewImg1" :srcList="srcList1" v-if="showPreviewImg1"></PreviewImg>
    </Layout>
</template>

<style scoped lang="scss">
.active2111 {
    background-color: #0AB39C !important;
    // color: #0AB39C;
}

label {
    margin-bottom: 0px;
}

.myC-3 {
    padding: 0.8rem 0 0.8rem 0;
}

.mx-3 {
    padding-left: 20px !important;
}

.el-tree {
    :deep(label) {
        margin-bottom: unset !important;
    }
}



.activeProgress {
    // background-image: linear-gradient(to right, #9599AD 0%, black 100%, );
    transition: background-image 0.1s linear;
}

@keyframes colorChange {
    0% {
        background-image: linear-gradient(to right, #9599AD 0%, black 100%);
    }

    20% {
        background-image: linear-gradient(to right, #9599AD 20%, black 80%);
    }

    40% {
        background-image: linear-gradient(to right, #9599AD 40%, black 60%);
    }

    60% {
        background-image: linear-gradient(to right, #9599AD 60%, black 40%);
    }

    80% {
        background-image: linear-gradient(to right, #9599AD 80%, black 20%);
    }

    100% {
        background-image: linear-gradient(to right, #9599AD 100%, black 0%);
    }
}
</style>